import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const AmenitiesSection = (): ReactElement => {
  const { t: tAmenities } = useTranslation('', { keyPrefix: '$local.$amenitiesSection' });
  const { t: tLinks } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$amenitiesSection',
  });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  return (
    <section className="base-section amenities-section hp-section">
      {/* Amenities Section */}
      <div className="main-hp hp-amenities stack-float-wrapper">
        <Link href={tLinks('amenitiesMain')} id="HP_amenities">
          <picture>
            <source srcSet="/images/homepage/hp-amenities.webp" media="(max-width: 620px)" />
            <img
              src="/images/homepage/hp-amenities.webp"
              alt={tAmenities('amenitiesAlt')}
              className="amenities-image"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              width={1300}
              height={550}
            />
          </picture>
          <div className="stack-float">
            <p className="eyebrow">{tAmenities('amenitiesEyebrow')}</p>
            <h2>{tAmenities('amenitiesTitle')}</h2>
            <p>{tAmenities('amenitiesDescription')}</p>
            <span className="btn-main">{tButton('shopNow')}</span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default AmenitiesSection;
